import { useCurrentUser } from "@/hooks/use-current-user";

// ADV-799: Today page role variants. Three buckets per the ticket:
//   rep       — salesperson + crew_chief (own-record framing, single-user copy)
//   manager   — endUserRole='manager' (team framing)
//   ops_admin — systemRole admin/super_admin (account framing)
//
// Data scope itself differs by role via CASL at the API layer. This variant
// helper only drives per-role section titles and lead copy on the Today page.
export type RoleVariant = "rep" | "manager" | "ops_admin";

export function useRoleVariant(): RoleVariant {
  const user = useCurrentUser();
  if (!user) return "rep";
  if (user.systemRole === "admin" || user.systemRole === "super_admin") {
    return "ops_admin";
  }
  if (user.endUserRole === "manager") return "manager";
  return "rep";
}
